import { Participant } from '@/interfaces/participant'
import { Utils } from '@/lib/utils'
import { InviteType } from '@/interfaces/invite'
import { SentRecipient } from '@/hooks/useSentRecipients'

export class InvitesHelper {
  static getInvitesByParticipant(participant: Participant, invitations: SentRecipient[]) {
    if (!participant) return []

    const unique: SentRecipient[] = []

    invitations.forEach((invite) => {
      const isParticipantInvite = invite.participants.some((item) => item.id === participant.id)
      const hasInResultArray = unique.some(
        (item) =>
          Utils.toLowerCase(item.address) === Utils.toLowerCase(invite.address) &&
          Utils.toLowerCase(item.name) === Utils.toLowerCase(invite.name) &&
          item.type !== InviteType.VISIT,
      )

      if (isParticipantInvite && !hasInResultArray) {
        unique.push(invite)
      }
    })

    return unique
  }

  static mergeRecipients(recipientsFromDb: SentRecipient[], recipientsFromStorage: SentRecipient[]) {
    const result: SentRecipient[] = []
    const invites = [...this.validateRecipients(recipientsFromDb), ...this.validateRecipients(recipientsFromStorage)]

    invites.forEach((invite) => {
      const hasInResultArray = result.some(
        (item) =>
          (item.address === invite.address && this.areParticipantsTheSame(item.participants, invite.participants)) ||
          (item.type === InviteType.FACEBOOK && invite.type === InviteType.FACEBOOK),
      )
      if (!hasInResultArray) {
        result.push(invite)
      }
    })

    return result
  }

  private static validateRecipients(recipients: SentRecipient[]) {
    return recipients && Array.isArray(recipients) ? recipients : []
  }

  private static areParticipantsTheSame(
    participantsFromDb: Participant[],
    participantsFromStorage: Participant[],
  ): boolean {
    const participantIdsDb = participantsFromDb.map((participant) => participant.id)
    const participantIdsStorage = participantsFromStorage.map((participant) => participant.id)

    return (
      participantIdsDb.length === participantIdsStorage.length &&
      participantIdsDb.sort().every((val, index) => val === participantIdsStorage[index])
    )
  }
}
